import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

const BiampLogoStyled = styled(Box)({
  width: '104.62px',
  height: '34px',
  display: 'inline-block',
  '& img': {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
  },
});

const BiampLogo = () => (
  <BiampLogoStyled>
    <img src="/images/Biamp_Logo.svg" alt="Biamp Logo" />
  </BiampLogoStyled>
);

export default BiampLogo;
